import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import ClickableDescr from 'components/ClickableDescr'
import Icon from 'components/Icon'
import SectionWrapper from 'components/SectionWrapper'
import { REGION_JP } from 'constants/regions'
import { US } from 'constants/countries'
import { ResizeContext } from 'contexts/Resize'
import { LocalizationContext } from 'contexts/Localization'
import { useSwitcher } from 'hooks/saveElementIndex'
import { H1Small as H1 } from 'styles/components/typography'

import {
  Cover,
  Content,
  FrameWrapper,
  FrameMacStraightStyled,
  IconWrapper,
  ImageWrapper,
} from './styles'

const IMAGES =
  process.env.region === REGION_JP
    ? [
        'bact_microbiome_150921',
        'bact_diversity_150921',
        'bact_citizenship_150921',
      ]
    : ['bact_microbiome', 'bact_diversity', 'bact_citizenship']

const BResultsBacteria = props => {
  const { data, pathCdn } = props
  const { index, updateIndex } = useSwitcher()
  const { mobile } = React.useContext(ResizeContext)
  const { colors } = React.useContext(ThemeContext)
  const { locale, paths: { shared } } = React.useContext(LocalizationContext)
  const isUs = locale === US

  return (
    <SectionWrapper
      isOverflowHidden={true}
      beforeElement={<Cover isTablet={true} />}
    >
      <div className='row'>
        <div className='col-12 order-md-1 col-md-8'>
          <Cover />
          <FrameWrapper className='py-md-4'>
            <div className='position-relative py-4 py-md-0'>
              <H1 as='h2' dangerouslySetInnerHTML={{ __html: data.title }} />

              <FrameMacStraightStyled
                src={`${pathCdn}/${IMAGES[index]}`}
                alt={IMAGES[index]}
              >
                {isUs ? (
                  <ImageWrapper className='bacteria' src={`${shared}/icons/bacteria.png`} alt={`bread_img`} />
                ) : (
                  <>
                    <IconWrapper className='sun'>
                      <Icon id='color_bacteria_sun' />
                    </IconWrapper>

                    <IconWrapper className='agro'>
                      <Icon id='color_bacteria_agro' />
                    </IconWrapper>
                  </>
                )}
              </FrameMacStraightStyled>
            </div>
          </FrameWrapper>
        </div>

        <div className='col-12 py-4 order-md-0 col-md-4'>
          <Content>
            <ul className='list--unstyled w-100'>
              {data.list.map((item, key) => (
                <ClickableDescr
                  key={key}
                  isActive={index === key}
                  noHover={mobile || data.list.length === 1}
                  onClick={() => updateIndex(key)}
                  arrowPosition='right'
                  bulletColor={colors.orange}
                  data={{
                    title: item.title,
                    description: item.content,
                  }}
                />
              ))}
            </ul>
          </Content>
        </div>
      </div>
    </SectionWrapper>
  )
}

BResultsBacteria.propTypes = {
  data: PropTypes.object.isRequired,
  pathCdn: PropTypes.string.isRequired,
}

export default BResultsBacteria
